/* eslint-disable prefer-destructuring */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-magic-numbers */
/* eslint-disable camelcase */
import Button from "@atlaskit/button";
import Select from "@atlaskit/select";
import Textfield from "@atlaskit/textfield";
import { ReactElement, useContext, useState } from "react";
import { MessageContext } from "../../contexts/Message/MessageContext";
import APIService from "../../services/API";
import "./AddAppointment.scss";
import { convertSlotsToOptions } from "./converts-slots";
import Disclaimer from "./Disclaimer";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}
interface UserResponse {
    id: string;
    firstName: string;
    lastName: string;
}
export interface Slots {
    date: number;
    coachesData: {
        userId: string;
        username: string;
    }[];
}

// duplicated in apollo api
export interface CreateAppointmentDto {
    coaches: string[];
    startDateTime: number;
}

export default function AddAppointment({}: Props): ReactElement {
    const [codeOrEmail, setCodeOrEmail] = useState("");
    const [users, setUsers] = useState<UserResponse[]>([]);
    const messageContext = useContext(MessageContext);
    const [valid, setValid] = useState(false);
    const [slots, setSlots] = useState<Slots[]>([]);
    const [selectedSlot, setSelectedSlot] = useState<{
        value: string;
        label: string;
    } | null>(null);

    const [selectedUser, setSelectedUser] = useState<{
        value: string;
        label: string;
    } | null>(null);

    const showSuccessMesage = (title: string) => {
        messageContext.actions.setMessage({
            title,
            isOpen: true,
            buttons: [
                {
                    buttonText: "OK",
                    onClick: () => messageContext.actions.closeModal(),
                },
            ],
        });
    };
    
    const showErrorMessage = (title: string) => {
        messageContext.actions.setMessage({
            title,
            isOpen: true,
            titleApparencce: "danger",
            buttons: [
                {
                    buttonText: "OK",
                    onClick: () => messageContext.actions.closeModal(),
                },
            ],
        });
    };

    const fetchUsers = () => {
        APIService.handlePostRequest<{ codeOrEmail: string }, UserResponse[]>(
            { codeOrEmail },
            `/users/users_by_code_or_email`
        )
            .then((usersList) => {
                setUsers(usersList);
                setSelectedUser(null);
                setSlots([]);
            })
            .catch((err) => {
                setUsers([]);
                setSlots([]);
                if (err.response.status === 404) {
                    showErrorMessage(
                        "Nutzer konnte nicht gefunden werden"
                    );
                }
                else {
                    showErrorMessage(
                        "Etwas ging schief. Der Termin konnte nicht erstellt werden"
                    );
                }

            });
    };
    const fetchSlots = () => {
        APIService.HandleGetRequest<Slots[]>(
            `/booking/user_and_coach_timeslots/${selectedUser?.value}`
        )
            .then((slotsList) => setSlots(slotsList))
            .catch(() => {
                setSlots([]);
                showErrorMessage(
                    "Etwas ging schief. Kann keinen Termin bekommen"
                );
            });
    };

    const addAppointment = () => {
        if (selectedSlot?.value) {
            const values = selectedSlot.value.split("$");
            APIService.handlePostRequest<CreateAppointmentDto, any>(
                {
                    coaches: [values[0]],
                    startDateTime: Number(values[1]),
                },
                `/appointments/create_as_coach_for_user/${selectedUser?.value}`
            )
                .then((res) => {
                    setUsers([]);
                    setSlots([]);
                    setSelectedSlot(null);
                    setSelectedUser(null);
                    setCodeOrEmail("");
                    showSuccessMesage("Termin erstellt!");
                })
                .catch((err) => {
                    if (err.response.data?.errorCode === 'E003') {
                        showErrorMessage(
                            "Es können nicht mehr als 3 Termine angelegt werden"
                        );
                    }
                    else {
                        showErrorMessage(
                            "Etwas ging schief. Termin kann nicht erstellt werden"
                        );
                    }
                });
        }
    };

    return (
        <div className="form-wrapper ">
            <small>
                <Disclaimer />
            </small>
            <div className="addAppointment-inputs-cont">
                <div className="addAppointment-email-cont">
                    <h3>Identifikationscode oder E-Mail Adresse</h3>
                    <Textfield
                        value={codeOrEmail || ""}
                        type="text"
                        onChange={(event) => {
                            /*
                             * Attlaskit has bad types here
                             */
                            // @ts-expect-error - Atlaskit types problem
                            const value = event.target.value;

                            if (
                                value?.length === 5 ||
                                value?.includes("@")
                            ) {
                                setValid(true);
                            } else {
                                setValid(false);
                            }

                            setCodeOrEmail(value.trim());
                        }}
                        placeholder=""
                    />
                    <br />
                    <Button
                        isDisabled={!valid}
                        appearance="primary"
                        onClick={fetchUsers}
                    >
                        Suche nach Benutzer
                    </Button>
                </div>
                {users.length > 0 && (
                    <div className="addAppointment-email-cont">
                        <h3>Benutzer auswählen</h3>
                        <Select
                            maxLength={5}
                            minLength={5}
                            value={selectedUser}
                            type="text"
                            options={users.map((user) => ({
                                label: `${user.firstName || "-"} ${user.lastName || "-"
                                }`,
                                value: user.id,
                            }))}
                            onChange={(event) => {
                                if (event) {
                                    setSelectedUser(event);
                                }
                            }}
                            placeholder=""
                        />
                        <br />
                        <Button
                            isDisabled={!selectedUser}
                            appearance="primary"
                            onClick={fetchSlots}
                        >
                            Verfügbare Termine anzeigen
                        </Button>
                    </div>
                )}

                {slots.length > 0 && (
                    <div className="addAppointment-avatar-cont">
                        <h3>Verfügbare Termine</h3>
                        <Select
                            maxLength={5}
                            minLength={5}
                            value={selectedSlot}
                            type="text"
                            options={convertSlotsToOptions(slots)}
                            onChange={(event) => {
                                if (event) {
                                    setSelectedSlot(event);
                                }
                            }}
                            placeholder=""
                        />
                        <br />
                        <Button
                            isDisabled={!selectedSlot}
                            appearance="primary"
                            onClick={addAppointment}
                        >
                            Termin erstellen
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
